import { SourceComponents } from '@updater/informant-core';
import { Checkbox } from '@updater/ui-uds';

export const SwitchField: SourceComponents['SwitchField'] = (props) => {
  return <Checkbox {...props} />;
};
